// breadcrumbNavigation.js

export function resolveBreadcrumb (level, page, team) {
  if (level === 1) {
    switch (page) {
      case 'team_edit':
        return { name: 'team', params: { id: team.id } }
      case 'gestor':
        return { name: 'team', params: { id: team.team ? team.team.id : false || team.id } }
      case 'players':
      case 'staff':
      case 'acompanyants':
      case 'players_add':
      case 'player_edit':
      case 'staff_add':
      case 'staff_edit':
      case 'acompanyants_add':
      case 'acompanyant_edit':
      case 'player':
      case 'coach':
      case 'acompanyant':
        return { name: 'team', params: { id: team.team ? team.team.id : false || team.id } }
      case 'club_edit':
        return { name: 'club' }
    }
  }

  if (level === 2) {
    switch (page) {
      case 'players_add':
      case 'player_edit':
      case 'player':
        return { name: 'players', params: { team_id: team.team.id } }
      case 'staff_add':
      case 'staff_edit':
      case 'staff':
      case 'coach':
        return { name: 'staff', params: { team_id: team.team.id } }
      case 'acompanyants_add':
      case 'acompanyant_edit':
      case 'acompanyant':
        return { name: 'acompanyants', params: { team_id: team.team.id } }
    }
  }

  return null
}
